import type { AccountPlatform } from './types';

/**
 * Реестр платформ — единственное место, где перечислены поддерживаемые сети.
 * Добавить YouTube = 'youtube' в AccountPlatform (types.ts) + запись сюда +
 * источник аккаунтов/статистики + стиль в PlatformBadge. Переключатели,
 * фильтры и подписи разбивок собираются из этого списка сами.
 */
export const ACCOUNT_PLATFORMS: readonly { id: AccountPlatform; label: string }[] = [
  { id: 'instagram', label: 'Instagram' },
  { id: 'tiktok', label: 'TikTok' },
];

/** Фильтр по платформе в сводках: конкретная сеть или все сразу. */
export type PlatformFilter = AccountPlatform | 'all';

// Сети, которые уже показываются карточками, но ещё не в сводках статистики.
const EXTRA_LABELS: Partial<Record<AccountPlatform, string>> = { youtube: 'YouTube', threads: 'Threads' };

export function platformLabel(id: AccountPlatform): string {
  return ACCOUNT_PLATFORMS.find((p) => p.id === id)?.label ?? EXTRA_LABELS[id] ?? id;
}

/** Подходит ли аккаунт под фильтр (у легаси-записей платформа не проставлена). */
export function matchesPlatform(
  platform: AccountPlatform | undefined,
  filter: PlatformFilter,
): boolean {
  return filter === 'all' || (platform ?? 'instagram') === filter;
}
